import api from './api'
import type { ApiResponse, AuthUser } from '@/types'

export const authService = {
  async me(): Promise<AuthUser | null> {
    try {
      const response = await api.get<ApiResponse<AuthUser>>('/auth/me')
      return response.data.data ?? null
    } catch (e: any) {
      // 401 просто значит "не залогинен" — это ожидаемый исход. Что-то ещё
      // (бэкенд лежит, сеть отвалилась) внешне неотличимо от разлогина, поэтому
      // хотя бы логируем, чтобы не гадать при отладке.
      if (e?.response?.status !== 401) {
        console.warn('auth.service.me() failed:', e)
      }
      return null
    }
  },

  async logout(): Promise<void> {
    await api.post('/auth/logout')
  },

  // Обычная ссылка, не XHR: бэкенд редиректит на Telegram
  loginUrl(next: string): string {
    return `${api.defaults.baseURL}/auth/telegram/login?next=${encodeURIComponent(next)}`
  }
}
